/* NEXORA · movimiento global: apariciones al hacer scroll e íconos line-md que se dibujan
   al entrar en pantalla. Solo se carga si el nivel de animación no es "Sin animación". */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const root = document.documentElement;
  root.classList.add('nx-motion');

  const icons = new WeakSet();
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;
        io.unobserve(el);
        if (el.hasAttribute('data-nx-draw')) {
          el.setCurrentTime(0);
          el.unpauseAnimations();
        } else {
          el.classList.add('is-in');
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
  );

  const scan = (scope) => {
    scope.querySelectorAll('[data-nx-reveal]:not(.is-in)').forEach((el) => io.observe(el));
    scope.querySelectorAll('svg[data-nx-draw]').forEach((svg) => {
      if (icons.has(svg)) return;
      icons.add(svg);
      if (typeof svg.pauseAnimations !== 'function') return;
      svg.pauseAnimations();
      io.observe(svg);
    });
  };

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
